import React from 'react';
import './CircularMarquee.scss';

const CircularMarquee = ({ html = '', speed = 10, pauseOnHover = false }) => {
  return (
    <div className={`marquee-wrapper ${pauseOnHover ? 'pause-on-hover' : ''}`}>
      <div
        className="marquee-content"
        style={{ animationDuration: `${speed}s` }}
      >
        <div
          className="marquee-text"
          dangerouslySetInnerHTML={{ __html: html }}
        />
        <div
          className="marquee-text"
          dangerouslySetInnerHTML={{ __html: html }}
        />
      </div>
    </div>
  );
};

export default CircularMarquee;